import { useEffect, useRef, useState } from "react";
import type { TaxonomyHit } from "../../../lib/api";

type Cat = { id: string; full_name: string };
export default function CategoryPicker({ value, alternatives, onSearch, onPick }: { value: Cat; alternatives: Cat[]; onSearch: (q: string) => Promise<TaxonomyHit[]>; onPick: (c: Cat) => void }) {
  const [q, setQ] = useState(""); const [hits, setHits] = useState<TaxonomyHit[]>([]);
  const searchRef = useRef(onSearch);
  useEffect(() => { searchRef.current = onSearch; });
  useEffect(() => {
    if (q.trim().length < 3) { setHits([]); return; }
    const t = window.setTimeout(() => { searchRef.current(q.trim()).then((h) => setHits(h.filter((x) => x.is_leaf))).catch(() => setHits([])); }, 300);
    return () => window.clearTimeout(t);
  }, [q]);
  return (
    <div className="space-y-2 font-mono text-sm">
      <div className="text-zinc-100 break-words">{value.full_name}</div>
      {alternatives.length > 0 && (
        <div className="flex flex-wrap gap-2">{alternatives.map((a) => <button key={a.id} onClick={() => onPick(a)} className="text-xs bg-zinc-800 hover:bg-zinc-700 px-2 py-1 rounded">{a.full_name.split(" > ").slice(-2).join(" > ")}</button>)}</div>
      )}
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="search categories…" className="w-full bg-zinc-950 border border-zinc-800 rounded px-3 py-2" />
      {hits.length > 0 && (
        <ul className="border border-zinc-800 rounded divide-y divide-zinc-800 max-h-56 overflow-auto">
          {hits.map((h) => <li key={h.id}><button onClick={() => { onPick({ id: h.id, full_name: h.full_name }); setQ(""); }} className="w-full text-left px-3 py-2 hover:bg-zinc-800 text-xs">{h.full_name}</button></li>)}
        </ul>
      )}
    </div>
  );
}
